import { render, staticRenderFns } from "./_images.vue?vue&type=template&id=1c1b795c&"
import script from "./_images.vue?vue&type=script&lang=js&"
export * from "./_images.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports